import { prepareZXingModule } from "zxing-wasm/reader";
// Vite emits this .wasm as a hashed asset served same-origin. The default
// zxing-wasm locateFile points at jsdelivr, which fails CORS preflight when
// App Insights adds a `traceparent` header to the fetch.
import zxingReaderWasmUrl from "zxing-wasm/reader/zxing_reader.wasm?url";

export function warmUpDecoder(): Promise<void> {
  try {
    // `fireImmediately: true` makes prepareZXingModule return the init Promise;
    // wrap in Promise.resolve so we don't depend on the union narrowing.
    const initPromise = prepareZXingModule({
      overrides: {
        locateFile: (path: string, prefix: string) =>
          path.endsWith(".wasm") ? zxingReaderWasmUrl : prefix + path,
      },
      fireImmediately: true,
    });
    return Promise.resolve(initPromise).then(() => undefined);
  } catch (err) {
    return Promise.reject(err);
  }
}
